
    import '/home/ec2-user/Youlify-Design/components/color-select/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["color-select-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/color-select/index.en-US.md?type=demo')
};